var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationLogoTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#D0E5EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 13L49.6506 26.5H6.34937L28 13Z",
    fill: "#AACED9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 50.2504V29H16.5V53.537C14.5356 52.651 12.6918 51.545 11 50.2504ZM19.5 54.6865V29H26.5L26.5 55.9605C24.0718 55.8323 21.7255 55.3948 19.5 54.6865ZM29.5 55.9605L29.5 29H36.5V54.6865C34.2745 55.3948 31.9282 55.8323 29.5 55.9605ZM39.5 53.537V29H45V50.2504C43.3082 51.545 41.4644 52.651 39.5 53.537Z",
    fill: "#AACED9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationLogoTwo);
export default __webpack_public_path__ + "static/media/education-logo-two.3d2530bbd5852afedf9617f6a34459aa.svg";
export { ForwardRef as ReactComponent };